import {isUnitTestMode, isCypress} from 'config/staticConfig';

const enableMocks = process.env.REACT_APP_ENABLE_MOCK === 'true';
const isCypressMocked = isCypress && enableMocks;
const getIsMocked = (flag: string | undefined) => isCypressMocked || isUnitTestMode || (enableMocks && flag === 'true');

//syntax for these will look weird but doing it this way gives us convenient typing
const generatePaperlessMocks = (): {
  mocked: boolean;
  accounts: 'multiple-accounts' | 'single-account';
  policies: 'no-policies' | 'life-policies' | 'life-policies-only' | 'policies' | 'life-policies-outage';
} => {
  //not using getIsMocked, not sure if it would interfere with Cypress testing due to policies overlap
  const mocked = enableMocks && process.env.REACT_APP_MOCK_PAPERLESS_PREFERENCES === 'true';
  const accounts =
    process.env.REACT_APP_MOCK_PAPERLESS_PREFERENCES_ACCOUNTS === 'multiple-accounts'
      ? 'multiple-accounts'
      : 'single-account';
  const policies = paperlessPolicies();
  return {mocked, accounts, policies};
};
const paperlessPolicies = () => {
  switch (process.env.REACT_APP_MOCK_PAPERLESS_PREFERENCES_POLICIES) {
    case 'no-policies':
      return 'no-policies';
    case 'life-policies':
      return 'life-policies';
    case 'life-policies-only':
      return 'life-policies-only';
    case 'life-policies-outage':
      return 'life-policies-outage';
    default:
      return 'policies';
  }
};
const generateQuotingGreenlightKnockout = (): {
  mocked: boolean;
  status: string | undefined;
  ruleId: string | undefined;
} => {
  const mocked = enableMocks && process.env.REACT_APP_MOCK_QUOTING_BIND_GREENLIGHT_KNOCKOUT === 'true';
  const status = process.env.REACT_APP_MOCK_QUOTING_BIND_GREENLIGHT_KNOCKOUT_STATUS;
  const ruleId = process.env.REACT_APP_MOCK_QUOTING_BIND_GREENLIGHT_KNOCKOUT_RULE_ID;
  return {mocked, status, ruleId};
};
const generateQuotingZestyKnockout = (): {
  mocked: boolean;
  eligibility: string | undefined;
} => {
  const mocked = enableMocks && process.env.REACT_APP_MOCK_QUOTING_BIND_ZESTY_KNOCKOUT === 'true';
  const eligibility = process.env.REACT_APP_MOCK_QUOTING_BIND_ZESTY_KNOCKOUT_ELIGIBILITY;
  return {mocked, eligibility};
};
export const Mocks = {
  Enabled: isUnitTestMode || enableMocks,
  Authentication: isUnitTestMode || (enableMocks && process.env.REACT_APP_MOCK_AUTHENTICATION === 'true'),
  BillingAccounts: getIsMocked(process.env.REACT_APP_MOCK_BILLING_ACCOUNTS),
  BillingAccountsPendingPayments: getIsMocked(process.env.REACT_APP_MOCK_BILLING_ACCOUNTS_PENDING_PAYMENTS),
  BillingAccountsInCancellationPayment1: getIsMocked(
    process.env.REACT_APP_MOCK_BILLING_ACCOUNTS_IN_CANCELLATION_PAYMENT1
  ),
  BillingAccountsInCancellationPayment2: getIsMocked(
    process.env.REACT_APP_MOCK_BILLING_ACCOUNTS_IN_CANCELLATION_PAYMENT2
  ),
  BillingAccountsInCancellationUnderPayment: getIsMocked(
    process.env.REACT_APP_MOCK_BILLING_ACCOUNTS_IN_CANCELLATION_UNDER_PAYMENT
  ),
  LifeBillingAccounts: getIsMocked(process.env.REACT_APP_MOCK_LIFE_BILLING_ACCOUNTS),
  BillingAccountsLifeOutage: getIsMocked(process.env.REACT_APP_MOCK_BILLING_ACCOUNTS_LIFE_OUTAGE),
  BillingAccountsTransactions: getIsMocked(process.env.REACT_APP_MOCK_BILLING_ACCOUNTS_TRANSACTIONS),
  BillingPoliciesTransactions: getIsMocked(process.env.REACT_APP_MOCK_BILLING_POLICIES_TRANSACTIONS),
  Claims: getIsMocked(process.env.REACT_APP_MOCK_CLAIMS),
  CreateAccount: getIsMocked(process.env.REACT_APP_MOCK_CREATE_ACCOUNT),
  Documents: getIsMocked(process.env.REACT_APP_MOCK_DOCUMENTS),
  DocumentUploader: getIsMocked(process.env.REACT_APP_MOCK_DOCUMENT_UPLOADER),
  EProxy: getIsMocked(process.env.REACT_APP_MOCK_EPROXY),
  ESignDocumentURLs: getIsMocked(process.env.REACT_APP_MOCK_ESIGN_DOCUMENT_URLS),
  ESignEnvelopes: getIsMocked(process.env.REACT_APP_MOCK_ESIGN_ENVELOPES),
  EditHomeDeductibles: getIsMocked(process.env.REACT_APP_MOCK_EDIT_HO_COVERAGES),
  EditLicenseNumber: getIsMocked(process.env.REACT_APP_MOCK_EDIT_LICENSE),
  EstimateDriver: getIsMocked(process.env.REACT_APP_MOCK_ESTIMATE_DRIVER),
  EditLender: getIsMocked(process.env.REACT_APP_MOCK_EDIT_LENDER),
  Messages: getIsMocked(process.env.REACT_APP_MOCK_MESSAGES),
  Party: getIsMocked(process.env.REACT_APP_MOCK_PARTY),
  PartyAccountOutage: getIsMocked(process.env.REACT_APP_MOCK_PARTY_ACCOUNT_OUTAGE),
  PartyLifeOutage: getIsMocked(process.env.REACT_APP_MOCK_PARTY_LIFE_OUTAGE),
  Paperless: generatePaperlessMocks(),
  Policies: getIsMocked(process.env.REACT_APP_MOCK_POLICIES),
  Quoting: getIsMocked(process.env.REACT_APP_MOCK_QUOTING),
  QuotingEAS: process.env.REACT_APP_MOCK_QUOTING_EAS === 'true',
  QuotingGreenlightKnockout: generateQuotingGreenlightKnockout(),
  QuotingZestyKnockout: generateQuotingZestyKnockout(),
  QuoteAddVehicleReplaceVinFlow: getIsMocked(process.env.REACT_APP_MOCK_QUOTE_ADD_VEHICLE_REPLACE_VIN_FLOW),
  QuotingAutoPrefill: getIsMocked(process.env.REACT_APP_MOCK_QUOTING_AUTO_PREFILL),
  QuotingHomePrefill: getIsMocked(process.env.REACT_APP_MOCK_QUOTING_HOME_PREFILL),
  QuotingRemove: getIsMocked(process.env.REACT_APP_MOCK_QUOTING_REMOVE),
  RemoveVehicle: getIsMocked(process.env.REACT_APP_MOCK_REMOVE_VEHICLE),
  RemoveLender: !isUnitTestMode && !isCypress && process.env.REACT_APP_MOCK_REMOVE_LENDER === 'true',
  ServiceProviderSearch: process.env.REACT_APP_MOCK_SERVICE_PROVIDER_SEARCH === 'true',
  Submissions: getIsMocked(process.env.REACT_APP_MOCK_SUBMISSIONS),
  Texting: getIsMocked(process.env.REACT_APP_MOCK_TEXTING),
  VehicleOptions: getIsMocked(process.env.REACT_APP_MOCK_VEHICLE_OPTIONS)
};
